import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  Radio,
  MenuItem,
  FormControl,
  Select,
  OutlinedInput,
  Chip,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { getAlignmentList } from "../../../actions/mygoal";
import { useSelector, useDispatch } from "react-redux";
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom'
import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import cssVariables from "../../../theme/cssVariables";
import { ReactComponent as LinkActive } from "../../../icons/link-goal-active.svg";
import { ReactComponent as LinkInactive } from "../../../icons/link-goal-inactive.svg";
import { ReactComponent as CasActive } from "../../../icons/cas-active.svg";
import { ReactComponent as CasInactive } from "../../../icons/cas-inactive.svg";
import { ReactComponent as BackIcon } from "../../../icons/arrow-left.svg";

const MyGoalChooseAlignment = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const _ = require("lodash");
  let { id } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();

  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
  };

  // Function Start
  const back = (val) => {
    if(showAlignment) {
      setShowAlignment(false);
    } else {
      goto(val, state)
    }
  }

  const goto = (route, data) => {
    navigate("/kpi"+route, { replace: false, state: data });
  }

  const chooseAlignment = () => {
    var stateOption = {...selectOption};
    if(showAlignment == false) {
      setShowAlignment(true);
      setType(null)
      setValue([])
      if(selectLibrary == 1) {
        stateOption['type'] = ['Associated Goal','Parent Goal'];
        stateOption['value'] = alignmentOption;
      } else {
        stateOption['type'] = ['Member', 'Team'];
        stateOption['value'] = [];
      }
      setSelectOption(stateOption)
    } else {
      const data = Object.assign(state, {
        alignment: selectLibrary,
        alignmentOption: alignmentOption,
        type: type,
        value: value,
        selectOption: stateOption,
      })
      goto('/mygoal-create-editable/result', data)
    }
  }

  const skipAlignment = () => {
    var stateOption = {...selectOption};
    const data = Object.assign(state, {
      alignment: null,
      alignmentOption: alignmentOption,
      type: [],
      value: [],
      selectOption: stateOption,
    })
    goto('/mygoal-create-editable/result', data)
  }

  const handleChange = (event, type) => {
    var stateOption = {...selectOption};

    const {
      target: { value },
    } = event;
    if(type == 'type') {
      if(selectLibrary == 2) {
        stateOption['value'] = value == 'Member' ? memberOption : memberTeamOption
      }
      setType(value)
    } else if (type == 'value') {
      setValue(value)
    }
    setSelectOption(stateOption);
  };

  const requireField = (text) => {
    return(
    <Grid container direction="row">
      <Grid>
        <Typography>{text}</Typography>
      </Grid>
      <Grid>
        <Typography style={{color: 'red'}}>&nbsp;*</Typography>
      </Grid>
    </Grid>)
  }

  const chooseLibrary = (val) => {
    setLibrary(val)
  }
  // Function End

  // Variable Start
  const [selectLibrary, setLibrary] = React.useState(1);
  const [showAlignment, setShowAlignment] = React.useState(false);
  const [type, setType] = React.useState(null);
  const [value, setValue] = React.useState([]);
  const [selectOption, setSelectOption] = React.useState({})
  const [memberOption, setMemberOption] = React.useState([])
  const [memberTeamOption, setMemberTeamOption] = React.useState([])
  const [alignmentOption, setAlignmentOption] = React.useState([])
  // Variable End

  useEffect(() => {
    if(state) {
      setSelectOption(state.selectOption)
      setMemberOption(state.memberOption)
      setMemberTeamOption(state.memberTeamOption)
    }
    dispatch(getAlignmentList())
      .then(resp => {
        setAlignmentOption(resp.data.goalAlignmentList)
      })
  },[])

  return (
    <>
      <Helmet>
        <title>MyGoalDetail | KPI </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => goto('/kpi/home')}>
                {t('label.home')}
              </span> /
              <span style={styles.link} onClick={() => goto('/mygoal', state)}>
                {` ${t('mygoal.page.mygoal')}`}
              </span> /
              <span style={styles.end} >
                {` ${t('mygoal.page.libraryGoal')} `}
              </span>
            </Typography>
          </Grid>
          <Grid container textAlign="center">
            <Grid item md={12} >
              <Typography variant="h1" fontSize={36} lineHeight="39.6px" fontWeight="500">
                {`Goal Alignment`}
              </Typography>
            </Grid>
            <Grid item md={12} pr={1} mt={1} mb={3}>
              <Typography fontSize={16}>
                {`Select the linking goal type for linking or cascading goal. `}
              </Typography>
            </Grid>
          </Grid>
          {showAlignment
            ?
            <Box backgroundColor="#FFF" style={{paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 50}} mb={3}>
              <Grid container>
                <Grid item mb={2}>
                  <Typography fontSize={22} fontWeight={600}>
                    {selectLibrary == 1 ? 'Linking Goal' : 'Cascading Goal'}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid lg={12} xs={12} item>
                  <Typography>
                    {selectLibrary == 1 ? requireField('Linking Goal Type') : requireField('Assigned Type')}
                  </Typography>
                </Grid>
                <Grid lg={12} xs={12} item>
                  <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      value={type}
                      onChange={(val) => {handleChange(val, 'type')}}
                      input={<OutlinedInput size="small" />}
                      renderValue={(selected) => {
                        if(selected == null) {
                          return <em>{selectLibrary == 1 ? 'Select linking goal type' : 'Select assigned type'}</em>;
                        } else {
                          return selected
                        }
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>{selectLibrary == 1 ? 'Select linking goal type' : 'Select assigned type'}</em>
                      </MenuItem>
                      {selectOption.type.map((option, idx) => {
                        return <MenuItem key={idx} value={option}>{option}</MenuItem>
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid lg={12} xs={12} item>
                  <Typography>
                    {selectLibrary == 1 ? requireField('Linked goal') : requireField('Assigned members')}
                  </Typography>
                </Grid>
                <Grid lg={12} xs={12} item>
                  <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      value={value}
                      multiple
                      onChange={(val) => {handleChange(val, 'value')}}
                      input={<OutlinedInput size="small" />}
                      renderValue={(selected) => {
                        if(selected.length == 0) {
                          return <em>{selectLibrary == 1 ? 'Select your linked goal' : 'Select your assigned members'}</em>;
                        } else {
                          return <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((value, idx) => (
                              <Chip key={idx} label={selectLibrary == 1 ? value.name : `${value.firstName} ${value.lastName ?? ''}`} style={{borderRadius: '6px', backgroundColor: '#5DA196', color: 'white'}}  />
                            ))}
                          </Box>
                        }
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>{selectLibrary == 1 ? 'Select your linked goal' : 'Select your assigned members'}</em>
                      </MenuItem>
                      {selectLibrary == 1 
                        ?
                          selectOption.value.map((option, idx) => {
                            return <MenuItem key={idx} value={option}>{option.name}</MenuItem>
                          })
                        :
                          selectOption.value.map((option, idx) => {
                          return <MenuItem key={idx} value={option}>
                            {option.firstName} {option.lastName}
                          </MenuItem>
                          })
                      }
                    </Select>
                  </FormControl>
                </Grid>
                <Grid lg={12} xs={12} item>
                  <Typography fontSize={14} variant="label">
                    {selectLibrary == 1 ? `Linked goal: ${value.length} items` : `Assigned members: ${value.length} members`}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            : 
            <Grid container spacing={6} pl={3} pr={3} pb={20} justifyContent="center">
              <Grid lg={3} xs={12} item>
                <Card style={{cursor: 'pointer'}} onClick={() => {chooseLibrary(1)}}>
                  <CardContent>
                    <Grid item lg={12} xs={12} container textAlign="center">
                      <Grid item>
                        <Radio name="radio" value="1" checked={selectLibrary === 1} size="small" />
                      </Grid>
                      <Grid item lg={12} mt={3}>
                        {selectLibrary === 1 ? <LinkActive /> : <LinkInactive />}
                      </Grid>
                      <Grid item lg={12} mt={5}>
                        <Typography fontSize={18} lineHeight="21px" fontWeight="600">
                          Linking Goal
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid lg={3} xs={12} item>
                <Card style={state.canCascading ? {cursor: 'pointer'} : {cursor: 'not-allowed'}} onClick={state.canCascading ? () => {chooseLibrary(2)} : () => {}}>
                  <CardContent>
                    <Grid item lg={12} xs={12} container textAlign="center">
                      <Grid item>
                        <Radio name="radio" value="2" checked={selectLibrary === 2} size="small" />
                      </Grid>
                      <Grid item lg={12}>
                        {selectLibrary === 2 ? <CasActive /> : <CasInactive />}
                      </Grid>
                      <Grid item lg={12} mt={3}>
                        <Typography fontSize={18} lineHeight="21px" fontWeight="600">
                          Cascading Goal
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          }
          <Grid container direction="row" style={{marginTop: '85px'}}>
            <Grid container xs={1} direction="row" style={{alignItems: 'center', justifyContent: 'center', cursor: 'pointer'}} onClick={() => back(`/mygoal-create/${id}`)}>
              <Grid item mt={0.5}>
                <BackIcon />
              </Grid>
              <Grid item ml={1}>
                <Typography>
                  Back
                </Typography>
              </Grid>
            </Grid>
            <Grid lg={10} xs={12} item textAlign="center">
              <Button
                size="small"
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={() => {chooseAlignment()}}
                color="primary"
                variant="contained"
                style={{ paddingLeft: 30, paddingRight: 30, textTransform: 'none' }}
                >
                <Typography>{'Next'}</Typography>
              </Button>
            </Grid>
            {!showAlignment &&
              <Grid container lg={1} xs={1} direction="row" style={{alignItems: 'center', justifyContent: 'right', cursor: 'pointer'}} onClick={() => skipAlignment()}>
                <Typography variant="label">
                  Skip
                </Typography>
              </Grid>
            }
          </Grid>
        </Container>
      </Box>
    </>
  );
};
export default MyGoalChooseAlignment;
